export default {
  props: {
    /**
     * 分校识别码
     */
    locale: {
      default: '',
      type: String,
    },

    /**
     * 组件源数据
     */
    componentList: {
      default: () => [],
      type: Array,
    },
  },
  data() {
    const { minFirstScreenModule } = this.$store.state.customPage
    const tempComponentList = []
    // const schoolCode = this.$store.state.schoolCode;
    this.componentList.forEach((item, index) => {
      // if (item.type === 52 && !(schoolCode == '6001' || schoolCode == '8601')) return
      try {
        if (item.content) {
          const componentContent = JSON.parse(item.content)
          tempComponentList.push({
            key: `${componentContent.componentName}-${index}`,
            moduleId: item.id,
            componentName: componentContent.componentName,
            componentType: componentContent.componentType,
            componentTitle: componentContent.componentTitle,
            componentData: componentContent.componentData,
            registration: componentContent.registration || {},
          })
        } else {
          tempComponentList.push({
            key: `${item.componentName}-${index}`,
            moduleId: item.id,
            ...item,
          })
        }
      } catch (error) {
        console.error(error)
      }
    })
    if (process.client) {
      console.group('自定义页面数据')
      console.log(`页面路径: ${this.$route.path}`)
      console.log('组件数据', tempComponentList)
      console.log('组件数据2', this.componentList)
      console.groupEnd()
    }
    // console.log('组件数据：', JSON.stringify(tempComponentList))

    // 初始渲染列表
    // 当存在 Category 或 resourcesColumn 时，先仅渲染到最先出现的一个（含），其后的组件待其加载完成后再追加渲染
    const firstGateIndex = tempComponentList.findIndex((item) => {
      const name = (item.componentName || '').toLowerCase()
      return name === 'category' || name === 'resourcescolumn'
    })
    const renderComponentList = firstGateIndex >= 0
      ? tempComponentList.slice(0, firstGateIndex + 1)
      : tempComponentList
    const loadedCount = 0
    const appendedAfterGate = firstGateIndex === -1
    return {
      minFirstScreenModule,
      tempComponentList,
      renderComponentList,
      loadedCount,
      firstGateIndex,
      appendedAfterGate,
    }
  },
  mounted() {
    // 异步渲染剩余组件模块
    // if (this.tempComponentList.length > this.minFirstScreenModule) {
    //   this.renderComponentList = this.renderComponentList.concat(this.tempComponentList.slice(this.minFirstScreenModule))
    // }
    let cls = 0;
    new PerformanceObserver((entryList) => {
      entryList.getEntries().forEach((entry) => {
        if (!entry.hadRecentInput) {
          cls += entry.value;
          console.log('Current CLS value:', cls, entry);
        }
      });
    }).observe({ type: 'layout-shift', buffered: true });
    if (this.$route.query.source_id) {
      window.sessionStorage.setItem('source_id', this.$route.query.source_id);
    }
    console.log(window.sessionStorage.getItem('preference'), 'preference');
    if (this.$route.query.preference) {
      if (window.localStorage.getItem('preference') !== this.$route.query.preference) {
        if (this.$route.query.preference === 'phone' || this.$route.query.preference === 'email') {
          window.localStorage.setItem('preference', this.$route.query.preference);
        }
      }
    }
    if (this.$route.query.sourceType) {
      window.sessionStorage.setItem('source_type', this.$route.query.sourceType);
    }
  },
  methods: {
    getTrackData(componentData) {
      if (process.server) return {};
      return {
        cms_component_type: componentData.componentType,
        cms_component_name: componentData.componentName,
        cms_component_title: componentData.componentTitle,
        cms_component_id: componentData.moduleId,
        previous_source: this.$route.name,
        cms_component_platform: window.JsInjectionActivity ? 'app' : process.env.CLIENT_TYPE, // 添加平台标识
      }
    },
    onChildMounted() {
      // 仅做计数，不在 mounted 时就追加 Category 后的组件
      this.loadedCount += 1
      // 若存在 Category 且尚未追加其后的组件，则暂不触发总体完成事件
      if (this.firstGateIndex >= 0 && !this.appendedAfterGate) {
        return
      }
      if (this.loadedCount === this.renderComponentList.length) {
        this.$emit('components-loaded')
      }
    },

    // 当 Category 或 resourcesColumn 内部完成后，由其向外透传的事件触发
    onCategoryLoaded(item) {
      if (
        item
          && typeof item.componentName === 'string'
          && (item.componentName.toLowerCase() === 'category' || item.componentName.toLowerCase() === 'resourcescolumn')
          && this.firstGateIndex >= 0
          && !this.appendedAfterGate
      ) {
        this.renderComponentList = this.renderComponentList.concat(
          this.tempComponentList.slice(this.firstGateIndex + 1),
        )
        this.appendedAfterGate = true
      }
    },
  },
}
